import React from 'react';
import { Menu, MenuItem, MenuDivider } from '../menu';
import Callout from '../callout';
import { usePatientGroup } from '../../../contexts/patient-group';
import Icon from '../../atoms/icon';
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons';
import { useMetaData } from '../../../contexts/metadata';
import { TogglePatientGroupFormFn } from '../../../libs/group';

interface IPatientGroupSelect {
  toggleForm: TogglePatientGroupFormFn;
}

const PatientGroupSelect: React.FC<IPatientGroupSelect> = ({ toggleForm }) => {
  const { account } = useMetaData();
  const { data, setActiveGroup } = usePatientGroup();
  const { terms } = useMetaData();
  const groups = data ? data.groups : [];

  const changeActiveGroup = (id: number) => {
    toggleForm('edit', true);
    setActiveGroup(id);
  };

  return (
    <Menu>
      <MenuItem
        onClick={() => toggleForm('new')}
        text={
          <span>
            <Icon icon={faPlusCircle} className="mr-2" />
            Create New {terms.patient.capitalized} View
          </span>
        }
      />
      <MenuDivider />
      {!account.isEnterprise ? (
        <React.Fragment>
          <MenuItem
            active={data && data.activeGroupId === null}
            onClick={() => changeActiveGroup(-1)}
            text="All Patients"
          />
          <MenuDivider />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Callout intent="primary" className="text-small">
            Since this is an enterprise account,
            <br />
            the All {terms.patient.pluralCapitalized} View is disabled.
          </Callout>
          <MenuDivider />
        </React.Fragment>
      )}
      {groups?.length > 0 &&
        groups.map((group, i) => (
          <React.Fragment key={group.id}>
            <MenuItem
              active={group.id === data.activeGroupId}
              onClick={() => changeActiveGroup(group.id)}
              text={group.name}
            />
            {i === groups.length - 1 ? null : <MenuDivider />}
          </React.Fragment>
        ))}
    </Menu>
  );
};

export default PatientGroupSelect;
